let $header = $('.header');
// Adjust scroll position for anchor links due to fixed header
((w) => {
  const shiftWindow = () => {
    if ($header.css('position') === 'fixed') {
      const h = -$header.height();
      w.scrollBy(0, h);
    }
  };
  if (w.location.hash) shiftWindow();
  w.addEventListener('hashchange', shiftWindow);
})(window);

// Adjust page top padding according to size of fixed header
export const resizeHeader = () => {
  if ($header.css('position') === 'fixed') {
    const offset = $header.height();
    $('main').css('padding-top', offset);
    $('.off-canvas-wrapper').css('top', offset);
  } else {
    $('main').css('padding-top', '');
  }
};

export default () => {
  // Observer for resizing the header and main padding if turbo-container is inserted. Inserting the container has caused overlapping between main page content and header content.
  $(document).ready(() => {
    // observer that does something if a mutation happens, ie. the child list has changed - the turbo container is added.
    const headerObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        for (i = 0; i < mutation.addedNodes.length; i++) {
          if ($(mutation.addedNodes[i]).hasClass('trboModuleContainer')) {
            setTimeout(() => {
              resizeHeader();
            }, 300);
          }
        }
        // disconnect the observer after container ist inserted and header is resized
        headerObserver.disconnect();
      });
    });
    // Observe the header if the list of child element changes - in checkout there is no such element
    if (document.getElementById('page-header')) {
      headerObserver.observe(document.getElementById('page-header'), {
        childList: true,
      });
    }

    $('form[name="suchformular"]').submit(function (q) {
      console.log(q);
      if ($.trim($("[name='q']").val()) === '') {
        q.preventDefault();
      }
      //
    });
  });
};
